import { render } from "./NavbarCompSecondary.vue?vue&type=template&id=d2246170"
import script from "./NavbarCompSecondary.vue?vue&type=script&lang=js"
export * from "./NavbarCompSecondary.vue?vue&type=script&lang=js"

import "./NavbarCompSecondary.vue?vue&type=style&index=0&id=d2246170&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__